/**
 *
 * @component 个人中心/我的方案/项目管理——添加成员
 *
 **/
import BaseModal from '&/components/BaseModal';
import { InfoCircleFilled } from '@ant-design/icons';
import { message, Input, Image, Button } from 'antd';
import './AddTurbineModal.scss';
function AddTurbineModal(props) {
    const { visible, setVisible } = props;

    const TITLES = {
        add: intl.get('projectMember.add'),
        share: intl.get('projectMember.share'),
    };

    const reducer = (state, action) => {
        return {
            title: TITLES[action.type],
            step: action.type,
        };
    };

    const [currentState, dispatch] = React.useReducer(reducer, {
        title: TITLES['add'],
        step: 'add',
    });

    // 关闭modal 初始化form数据
    const closeModal = () => {
        dispatch({ type: 'add' });
        setVisible(false);
    };

    const [select, setSelect] = useState(0);

    const identityList = [
        {
            icon: require('@/assets/img/userCenter/sjs.png').default,
            name: intl.get('projectMember.designer'),
            desc: intl.get('projectMember.designerAuthority'),
        },
        {
            icon: require('@/assets/img/userCenter/sgf.png').default,
            name: intl.get('projectMember.builders'),
            desc: intl.get('projectMember.buildersAuthority'),
        },
        {
            icon: require('@/assets/img/userCenter/ku.png').default,
            name: intl.get('projectMember.user'),
            desc: intl.get('projectMember.userAuthority'),
        },
    ];

    const selectIdentity = idx => {
        setSelect(idx);
    };

    const generateLink = () => {
        dispatch({ type: 'share' });
    };

    const ref = useRef();

    const link =
        'https://www.foxithd.com/online/site/pcenter/projectmanage?inviteId=3FO4K4W0Y3FU';

    // 两种方式复制到剪切板
    const copyLink = async () => {
        const { clipboard } = navigator;
        try {
            if (!clipboard) throw new Error();
            await clipboard.writeText(link);
        } catch {
            ref.current.resizableTextArea.textArea.select();
            document.execCommand('copy');
        } finally {
            message.success(intl.get('projectMember.copySuccess'));
        }
    };

    const CONTENT = {
        add: (
            <div className="add-step">
                <header className="hint">
                    <InfoCircleFilled className="hint-icon" />
                    {intl.get('projectMember.memberLimit')}
                </header>
                <div className="group-name">
                    {intl.get('projectMember.selectRole')}
                </div>
                {identityList.map((el, idx) => (
                    <section
                        className={`${
                            idx === select
                                ? 'identity-items identity--select'
                                : 'identity-items'
                        }`}
                        key={idx}
                        onClick={() => selectIdentity(idx)}>
                        <Image
                            className="identity-icon"
                            src={el.icon}
                            preview={false}
                        />
                        <div className="identity-content">
                            <div className="identity-name">{el.name}</div>
                            {el.desc}
                        </div>
                    </section>
                ))}
                <footer className="add-step-footer">
                    <Button onClick={generateLink}>
                        {intl.get('projectMember.generateLink')}
                    </Button>
                </footer>
            </div>
        ),
        share: (
            <div className="share-step">
                <div className="group-name">
                    {intl.get('projectMember.shareLink')}
                </div>
                <div className="copy-link">
                    <Input.TextArea
                        ref={ref}
                        value={link}
                        autoSize
                        bordered={false}
                        readonly></Input.TextArea>
                    <Button type="primary" onClick={copyLink}>
                        {intl.get('projectMember.copy')}
                    </Button>
                </div>
                <div className="group-name">
                    {intl.get('decorationDesign.qrCodeShare')}
                </div>
                <footer className="qrcode">
                    <Image
                        preview={false}
                        className="qrcode-image"
                        src={require('@/assets/img/qrc.png').default}></Image>
                    {intl.get('decorationDesign.qrCodeShare')}
                </footer>
            </div>
        ),
    };
    return (
        <BaseModal
            className="add-turbine base-custom-modal"
            visible={visible}
            width="27.5rem"
            bodyStyle={{ padding: currentState.step === 'add' ? '1.25rem' : 0 }}
            title={currentState.title}
            footer={null}
            onCancel={closeModal}>
            {CONTENT[currentState.step]}
        </BaseModal>
    );
}

export default AddTurbineModal;
